import React from 'react';
import FeatureCard from './FeatureCard';
import sfeatures from '../../assets/images/sfeatures.jpg';
import beyond from '../../assets/images/beyond.jpg';

const Fecard = () => {

  return (
    <div className="container my-4">
      <div className="row g-4">
        <div className="col-md-6">
          <FeatureCard header="SALIENT FEATURES" image={sfeatures} descr="ONE" />
        </div>
        <div className="col-md-6">
          <FeatureCard header="BEYOND ACADEMICS" image={beyond} descr="TWO" />
        </div>
      </div>
    </div>
  );
};

export default Fecard;

